import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import croppedLogo from "../../assets/img/logo-cropped.png";
import { FaUserCircle, FaRegBell, FaRegUserCircle } from 'react-icons/fa';
import { HiMenuAlt1 } from 'react-icons/hi';
import { MdOutlineMenu, MdClose, MdLogout } from 'react-icons/md';
import { userLogoutAction } from "../../redux/actions/userActions"

const Header = ({ toggleNav, setToggleNav }) => {
  const dispatch = useDispatch()
  // const ref = useRef()

  const [dropdown, setDropdown] = useState(false)

  const userLogin = useSelector(state => state.userLogin)
  const { userInfo } = userLogin

  // --- Handling clicking outside --- //
  // useEffect(() => {
  //   const handleClickOutside = (e) => {
  //     if (ref.current && !ref.current.contains(e.target)) {
  //       setDropdown(false)
  //     }
  //   }

  //   document.addEventListener('click', handleClickOutside, true)
  //   return () => {
  //     document.removeEventListener('click', handleClickOutside, true)
  //   }
  // }, [])

  const handleLogoutUser = () => {
		dispatch(userLogoutAction())
	}

  return (
    <div id="admin-header">
      <div className="admin-header_cont">
        <button type="button" className="menu-btn" onClick={() => setToggleNav(!toggleNav)}>
          {toggleNav ? <MdClose size={30} /> : <MdOutlineMenu size={30} />}
        </button>
        <NavLink to="/dashboard" className="logo-area">
          <img src={croppedLogo} alt="Island Luxury" />
        </NavLink>
        <div className="user-area">
          <button type="button" className="notify-btn">
            <FaRegBell size={25} />
          </button>
          <button type="button" className="user-btn" onClick={() => setDropdown(!dropdown)} >
            <HiMenuAlt1 size={25} />
            <h3>{userInfo?.firstname}</h3>
            <FaUserCircle size={30} />
          </button>
        </div>
      </div>
      <div className={dropdown ? "dropdown display" : "dropdown"}>
        <div className="dropdown_cont">
          <NavLink to="/profile" className="dropdown_item">
            <FaRegUserCircle size={27} />
            <span>Profile</span>
          </NavLink>
          <button className="dropdown_item" onClick={handleLogoutUser}>
            <MdLogout size={27} />
            <span>Logout</span>
          </button>
        </div>
      </div>
    </div>
  )
}

export default Header;